import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import {
  fetchElevenlabsVoices,
  getElevenlabsVoices,
  getElevenlabsVoicesStatus,
} from "./state/gallerySlice";
import { GENERATE_MEDIA_PANEL_COMPONENT } from "./components/GenerateMediaPanel";

/**
 * Fetches the TTS voice catalogue the first time a component that needs it
 * mounts. Replaces the boot-time prefetch in App.tsx (removed for the login
 * fanout diet, docs/plans/partial/login-fanout-performance.md Phase 4). The
 * status guard makes three panels mounting together dispatch once, and a
 * failed fetch does not retry in a loop.
 */
export const useEnsureElevenlabsVoices = (enabled = true) => {
  const dispatch = useAppDispatch();
  const voices = useAppSelector(getElevenlabsVoices);
  const status = useAppSelector(getElevenlabsVoicesStatus);
  useEffect(() => {
    if (enabled && voices.length === 0 && status === "idle") {
      void dispatch(fetchElevenlabsVoices({ componentId: GENERATE_MEDIA_PANEL_COMPONENT }));
    }
  }, [dispatch, enabled, voices.length, status]);
};
